import { render } from "./template.vue?vue&type=template&id=54436e1f&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=54436e1f&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54436e1f"]])

export default __exports__